import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

const ResubmitModal = ({ 
    handleClose, show, onAdd }) => {
    const [rejectRemark, setRejectRemark] = useState("");

    const onSubmit = (e) => {
        e.preventDefault();
        if (rejectRemark == "") {
            alert('Please provide a remark for resubmission');
        } 
        else {
            if(!window.confirm('Do you want to submit this?')) {
                return false;
            }

            onAdd({
                rejectRemark,
            });
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title style={{ marginBottom: '0px' }}>
                    Resignation Form Resubmission
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form 
                onSubmit={onSubmit}
                >
                    <Form.Group className='mb-3'>
                        <Form.Label>Resubmission Remark</Form.Label>
                        <Form.Control
                            type='text'
                            placeholder='Please fill in the resubmission remark here...'
                            style={{ width: '100%' }}
                            value={rejectRemark}
                            onChange={(e) => setRejectRemark(e.target.value)}
                        />
                    </Form.Group>
                    <Button as='input' type='submit' value='Resubmit' />
                    <Button variant='outline-secondary' onClick={handleClose}>
                        Close
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ResubmitModal;
